export class AddRecipeModal {
  static profiles = [
    {
      name: 'Человек 1',
      index: 0,
      value: 100
    },
    {
      name: 'Человек 2',
      index: 1,
      value: 200
    },
    {
      name: 'Человек 3',
      index: 2,
      value: 100
    }
  ];
  static eating = [
    {
      name: 'завтрак',
      value: false
    },
    {
      name: 'обед',
      value: false
    },
    {
      name: 'ужин',
      value: false
    },
    {
      name: 'перекус',
      value: false
    },
  ];
  static days = [
    {
      name: 'пн',
      value: false
    },
    {
      name: 'вт',
      value: false
    },
    {
      name: 'ср',
      value: false
    },
    {
      name: 'чт',
      value: false
    },
    {
      name: 'пт',
      value: false
    },
    {
      name: 'сб',
      value: false
    },
    {
      name: 'вс',
      value: false
    },
  ];
}



// WEBPACK FOOTER //
// ./src/app/shared/dictionaries/AddRecipeModal.ts